import { render, staticRenderFns } from "./ModalAviso.vue?vue&type=template&id=8ab063ce&scoped=true"
import script from "./ModalAviso.vue?vue&type=script&lang=js"
export * from "./ModalAviso.vue?vue&type=script&lang=js"
import style0 from "./ModalAviso.vue?vue&type=style&index=0&id=8ab063ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab063ce",
  null
  
)

export default component.exports